import { MatDateFormats } from '@angular/material/core';

/**
 * Configuration object to manage XPO date formats
 */
export const XPO_DATE_RANGE_PICKER_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
